<template>
    <div class="container-fluid">
        <div class="row mt-2 mb-5">
            <div class="offset-md-2 col-md-8 col-12">
                <!-- stage numbering -->
                <div class="row my-2">
                    <div class="col-12 text-center">
                        <router-link :to="{ name: 'checkout-information' }" class="text-dark-green">
                            Information
                        </router-link> &gt;
                        <span class="text-dark-green">Shipping</span> &gt;
                        <span class="text-muted">Payment</span>
                    </div>
                </div>

                <!-- import cart review -->
                <app-cart-review class="my-3"></app-cart-review>

                <!-- show shipping items -->
                <template v-if="theItemsInCart">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <app-shipping-item 
                                    v-for="(item, index) in theItemsInCart" 
                                    :key="index" :item="item" 
                                ></app-shipping-item>
                            </div>
                        </div>
                    </div>

                    <!-- display alert messages for mobile -->
                    <div v-if="msg !== ''" :class="`alert alert-${color} text-center mt-3 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle fa-sm"></i> {{ msg }}
                    </div>

                    <!-- continue to payment button -->
                    <div class="row mt-2">
                        <div class="col-12">
                            <div class="float-sm-right">
                                <button @click.prevent="submitShipping" :to="{ name: 'checkout-payment' }" class="btn btn-dark-green form-control">
                                    Continue to Payment
                                </button>
                            </div>
                            <div class="float-sm-left">
                                <p class="text-center m-0 pt-2">
                                    <router-link :to="{ name: 'checkout-information' }">
                                        <i class="fas fa-chevron-left fa-xs"></i> Return to Information
                                    </router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CartReview from './CartReview.vue';
import ShippingItem from '../shoppingCartParts/ShippingItem.vue';
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "Shipping",
    data() {
        return {
            msg: '',
            color: 'danger',
        }
    },
    methods: {
        ...mapActions(['fetchCartItemsAction']),
        fetchCartItemsFxn() {
            // check if itemsInCart was already loaded by ShoppingCart.vue
            if(this.itemsInCart) return 

            let cartObj = {
                items: []
            }
            
            // obtain the cart-items from local-storage and updated cart obj
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                cartObj.items = localStorageATCItemIds
            } 
            this.fetchCartItemsAction(cartObj).then(() => {}).catch((e) => {})
        },
        submitShipping() {
            let shoppersCartArr = null

            // obtain the cart-items from local-storage 
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                shoppersCartArr = localStorageATCItemIds
            }

            // ensure cart items were obtained else quit
            if(!shoppersCartArr) return
            
            // loop through all cart items to ensure a shipping method was selected b4 redirecting
            let redirectToPayment = true
            for(let x=0; x < shoppersCartArr.length; x++){
                if(!shoppersCartArr[x].shippingMethod){
                    redirectToPayment = false
                    this.msg = "Select a shipping method for your items!"
                    break;
                }
            }

            if(!redirectToPayment) return
            
            // redirect to payment page
            this.$router.push({
                name: 'checkout-payment'
            }).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['itemsInCart']),
        theItemsInCart() {
            if(this.itemsInCart){
                return this.itemsInCart
            }
            return false
        },
    },
    components: {
        appCartReview: CartReview,
        appShippingItem: ShippingItem
    },
    created() {
        this.fetchCartItemsFxn()
        this.$emit('update:layout', LayoutGeneral);
    },
}
</script>
